// extracted by mini-css-extract-plugin
module.exports = {"leaf":"Leaf_leaf__W032y"};